// extracted by mini-css-extract-plugin
module.exports = {"DescriptionBox":"DescriptionBox_DescriptionBox__2K_-K","CompanyDescription":"DescriptionBox_CompanyDescription__3qYdD"};